// src/AnamorphicArt.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AnamorphicArt.css';

export default function AnamorphicArt() {
  const navigate = useNavigate();
  const publishDate = 'May 24, 2025';

  return (
    <div className="anamorphic-art-page">
      <article className="blogpost-container">
        <button className="back-btn" onClick={() => navigate('/blogs')}>
          ←
        </button>
        <header>
          <h1 className="blog-title">Anamorphic Art</h1>
          <time className="blog-date" dateTime="2025-05-24">
            {publishDate}
          </time>
        </header>

        <section className="blog-section">
          <p>
            Okay, time to pass down another skill. So this form of art is
            dependent on the perspective one looks at it from and can add
            depth to it when seen from a certain angle.
          </p>
        </section>

        <section className="blog-section">
          <h2>Shading Techniques</h2>
          <p>
            To learn this one must have some knowledge of shading techniques.
            It’s all a matter of the weight you apply to the pencil. Always
            start off with a basic outline of the structure with a bare minimal visibility.
            Once done, the shading begins. First step is getting the lighting right.
            It’s imagining a spot light pointing in a direction and the opposite
            figure should see the shadow. Find out whether the majority shade
            is light or dark since that determines what to start off with.
          </p>
          <p>
            Get the strokes in a single direction, always ensure a fine, grainy
            smooth texture. Then it's a matter of color completion layer by layer
            (get the lightest shade done and progress). That’s shading explained.
          </p>
          <figure className="blog-figure">
            <img
              src="/assets/f1carshowcase.webp"
              alt="Redbull RB20 using simple shading techniques"
              className="blog-image"
            />
            <figcaption className="blog-caption">
              Figure: Redbull RB20 using simple shading techniques
            </figcaption>
          </figure>
        </section>

        <section className="blog-section">
          <h2>Anamorphic Projection</h2>
          <p>
            Now coming to anamorphic art, the first rule is to keep everything
            proportionate meaning the angles of opposite edges are almost always
            parallel to each other. One trick for this is to place a point away
            from the actual structure and begin all lines from there. This is your
            point of view and the perspective where it all seems 3D.
          </p>
          <p>
            Once the projections are mapped out, outline the actual structure.
            It is similar to converting orthographic to isometric projections.
            After this it’s all about the shading which adds realism.
          </p>
          <figure className="blog-figure">
            <img
              src="/assets/juststairscropped.webp"
              alt="Stairs made anamorphic using chalk"
              className="blog-image"
            />
            <figcaption className="blog-caption">
              Figure: Chalk anamorphic stairs
            </figcaption>
          </figure>
        </section>

        <section className="blog-section">
          <p>
            After a certain level of practice, one should be able to convert any
            regular piece to anamorphic using these techniques. This style remains
            extremely unique and uncovers details that normally would be misunderstood.
            It serves like a hidden message. Then with a certain skill level,
            it's possible to display multiple depths and scenes at different
            angles of the same art piece. That’s what makes this one of the most
            challenging and creative forms of art.
          </p>
        </section>
      </article>
    </div>
  );
}